import { render, staticRenderFns } from "./examineQuestion.vue?vue&type=template&id=55589f32&scoped=true"
import script from "./examineQuestion.vue?vue&type=script&lang=js"
export * from "./examineQuestion.vue?vue&type=script&lang=js"
import style0 from "./examineQuestion.vue?vue&type=style&index=0&id=55589f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55589f32",
  null
  
)

export default component.exports